import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { ImportActivitiesHistoryForDataTable } from "../pages/import-data/ImportFilePopup.type";
import ImportFileService from "../service/import-file.service";
import alertService from "../components/alert/alertService";

type ImportFileState = {
  rows: ImportActivitiesHistoryForDataTable[];
  setRows: Dispatch<SetStateAction<ImportActivitiesHistoryForDataTable[]>>;
  downloadData: () => Promise<void>;
};

export const Context = createContext<ImportFileState>({} as ImportFileState);

export const ImportFileProvider = ({ children }: { children: ReactNode }) => {
  const [rows, setRows] = useState<ImportActivitiesHistoryForDataTable[]>([]);

  const downloadData = async () => {
    alertService.showLoading();
    try {
      const result = await ImportFileService.getImportHistories();
      if (result) {
        setRows(result);
      }
    } catch {
      // error alert already shown by service
    } finally {
      alertService.closeLoading();
    }
  };

  useEffect(() => {
    downloadData();
  }, []);

  return (
    <Context.Provider value={{ rows, setRows, downloadData }}>
      {children}
    </Context.Provider>
  );
};

export const ImportFileContext = () => useContext(Context);
